import clientAuth from "../clientAuth";

export default {
  index: () => clientAuth.get("ad_ons/index"),
  
  store: (userData) => clientAuth.post('ad_ons/store', { json: userData }),

  show:(id)=>clientAuth.get('ad_ons/show/'+id),

  update:(id,userData)=>clientAuth.post('ad_ons/update/'+id,{json:userData}),

  destroy:(id)=>clientAuth.delete(`ad_ons/destroy/${id}`),
};